function getAuthStr () {
  const authStr = window.sessionStorage.getItem('authStr')
  return authStr
}

export {getAuthStr}



// WEBPACK FOOTER //
// ./src/util/bus.js